import { handleActions } from 'redux-actions';
import {
    GET_FONT_LIST_SUCCESS,
    GET_FONT_LIST_FAILED,
    GET_FONT_LIST_REQUESTED,
    GET_FONT_LIST_NOT_FOUND
} from '../../constants/ActionTypes';

const initialState = {
    getFontList: {}
};

export default handleActions(
    {
        [GET_FONT_LIST_REQUESTED]: state => {
            const getFontList = {
                isLoading: true
            };
            return { ...state, getFontList };
        },
        [GET_FONT_LIST_SUCCESS]: state => {
            const getFontList = {
                isLoading: false,
                isHealthy: true
            };
            return { ...state, getFontList };
        },
        [GET_FONT_LIST_NOT_FOUND]: (state, { error }) => {
            const getFontList = {
                isLoading: false,
                isNotFound: true
            };
            return { ...state, getFontList };
        },
        [GET_FONT_LIST_FAILED]: (state, { options }) => {
            const getFontList = {
                isLoading: false,
                isHealthy: false,
                options
            };
            return { ...state, getFontList };
        }
    },
    initialState
);



// WEBPACK FOOTER //
// ./src/reducers/serviceHealth/theme.js